import Format from "../components/format/Format";

export default function Yaml() {

    return (
        <Format inputLabel='YAML' 
        buttons={[
                {
                    api: '/api/yaml/is-valid',
                    buttonLabel: 'Validate',
                    outputLabel: 'Valid',
                },
            ]} 
        />
    );
}